import React from 'react';
import DOMPurify from 'dompurify';

const HtmlWrapper = ({id, className, style, html}) => {
    const cleaned = DOMPurify.sanitize(html || '', {
        ADD_ATTR: ['target']
    });

    let attrs = {dangerouslySetInnerHTML: { __html: cleaned }};
    if (id) attrs.id = id;
    if (className) attrs.className = className;
    if (style) attrs.style = style;

    return (<div {...attrs}></div>);
};

export default HtmlWrapper;